import { cn } from "@/lib/utils";

export default function RightCaretIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[9px] w-1.5 text-white", className)}
      fill="none"
      viewBox="0 0 6 9"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.40527 4.66504C5.40527 4.7334 5.39225 4.7985 5.36621 4.86035C5.34017 4.91895 5.29948 4.97428 5.24414 5.02637L1.61621 8.57617C1.52507 8.67057 1.41276 8.71777 1.2793 8.71777C1.1849 8.71777 1.10189 8.69661 1.03027 8.6543C0.958659 8.61198 0.900065 8.55339 0.854492 8.47852C0.812174 8.4069 0.791016 8.32552 0.791016 8.23438C0.791016 8.10417 0.839844 7.99023 0.9375 7.89258L4.23828 4.66504L0.9375 1.4375C0.839844 1.33984 0.791016 1.22591 0.791016 1.0957C0.791016 1.0013 0.812174 0.918294 0.854492 0.84668C0.900065 0.775065 0.958659 0.718099 1.03027 0.675781C1.10189 0.633464 1.1849 0.612305 1.2793 0.612305C1.41276 0.612305 1.52507 0.659505 1.61621 0.753906L5.24414 4.30371C5.29948 4.35579 5.34017 4.41276 5.36621 4.47461C5.39225 4.5332 5.40527 4.59668 5.40527 4.66504Z"
        fill="currentColor"
      />
    </svg>
  );
}
